import React from 'react';
import { Form, FormProps } from 'antd';
import { ShouldUpdate } from 'rc-field-form/lib/Field';
import { isEqual } from 'lodash';

type Props = {
  onValuesChange: FormProps['onValuesChange']
}
export const FormChange: React.VFC<Props> = ({ onValuesChange }) => {
  const updateHandler: ShouldUpdate = (prevValues, currValues) => {
    const currKeys = Object.keys(currValues);

    const keys = currKeys.reduce((result, key) => {
      const cond = isEqual(prevValues[key], currValues[key]);
      return cond ? result : result.concat(key);
    }, []);

    if (keys.length) {
      keys.forEach(key => {
        const changedValues = { [key]: currValues[key] };
        onValuesChange(changedValues, currValues);
      });
    }
    return false;
  };

  return (
    <Form.Item shouldUpdate={updateHandler} noStyle>
      {() => {}}
    </Form.Item>
  );
};
